export const canUseOpenCodeProfileV95 = (type, groups, config = {}) => {
  const names = (
    Array.isArray(groups) ? groups : String(groups || '').split(',')
  )
    .map((name) => String(name).trim().toLowerCase())
    .filter(Boolean);
  return (
    [1, 50].includes(Number(type)) &&
    !(Number(type) === 50 && names.length === 1 && names[0] === 'vertex') &&
    !config.openai_compatible_profile &&
    !config.edge_proxy
  );
};

export const buildOutboundProfileSubmissionV95 = (
  type,
  groups,
  config = {}
) => {
  const result = { ...config };
  const profile = String(result.outbound_client_profile_v95 || '')
    .trim()
    .toLowerCase();
  if (!profile || !canUseOpenCodeProfileV95(type, groups, result)) {
    delete result.outbound_client_profile_v95;
  } else {
    result.outbound_client_profile_v95 = profile;
  }
  return result;
};
